import { Button } from "@/components/ui/button";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

/**
 * Prev/Next pagination for filtered lists.
 * Props:
 *   total: total rows matching current filters (number)
 *   filters: current filter object (must include page + page_size)
 *   setFilters: updater
 *   testid: optional base testid
 */
export default function Pagination({ total = 0, filters = {}, setFilters, testid = "pagination" }) {
  const page = Number(filters.page || 1);
  const pageSize = Number(filters.page_size || 25);
  const totalPages = Math.max(1, Math.ceil((total || 0) / pageSize));
  if (total <= pageSize) return null;
  const prev = () => setFilters({ ...filters, page: Math.max(1, page - 1) });
  const next = () => setFilters({ ...filters, page: Math.min(totalPages, page + 1) });
  const startIdx = (page - 1) * pageSize + 1;
  const endIdx = Math.min(total, page * pageSize);
  return (
    <div className="flex items-center justify-between gap-2 mt-3 text-sm" data-testid={testid}>
      <div className="opacity-70">
        Showing <b>{startIdx}</b>–<b>{endIdx}</b> of <b>{total}</b>
      </div>
      <div className="flex items-center gap-2">
        <Button size="sm" variant="outline" onClick={prev} disabled={page <= 1} data-testid={`${testid}-prev`}>
          <CaretLeft size={14} className="mr-1" /> Prev
        </Button>
        <span className="text-xs opacity-70 whitespace-nowrap">
          Page <b>{page}</b> of <b>{totalPages}</b>
        </span>
        <Button size="sm" variant="outline" onClick={next} disabled={page >= totalPages} data-testid={`${testid}-next`}>
          Next <CaretRight size={14} className="ml-1" />
        </Button>
      </div>
    </div>
  );
}
